<template>
  <section class="app-main">
    <transition name="fade" mode="out-in">
      <!-- <router-view :key="key"></router-view> -->
      <!-- <router-view></router-view> -->
      <keep-alive :include="cachedViews">
        <router-view :key="key" />
      </keep-alive>
    </transition>
  </section>
</template>

<script>
  export default {
    name: 'AppMain',
    computed: {
      cachedViews() {
        console.log('cachedviews', this.$store.state.tagsView.cachedViews);
        return this.$store.state.tagsView.cachedViews;
      },
      key() {
        console.log(this.$route.path, 'key----');
        return this.$route.path
        // return this.$route.name !== undefined ? this.$route.name + +new Date() : this.$route + +new Date()
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/views/layout/components/AppMain.vue